import {
  Contract,
  Interface,
  JsonRpcProvider,
  ZeroAddress,
  getAddress,
  isAddress,
} from "ethers";
import PresaleContractAddress from "./contractsData/PreSaleContract-address.json";
import PresaleContract from "./contractsData/PreSaleContract.json";

const rpcUrl = import.meta.env.VITE_RPC_URL_BNB;

export const TOKEN_DECIMALS = 18;

export const getReadProvider = () => {
  if (!rpcUrl) {
    throw new Error("VITE_RPC_URL_BNB is missing from the environment file.");
  }

  return new JsonRpcProvider(rpcUrl);
};

export const getProviderPresaleContract = () =>
  new Contract(
    PresaleContractAddress.address,
    PresaleContract.abi,
    getReadProvider(),
  );

export const normalizeReferrer = (referrer, buyerAddress) => {
  if (!referrer || !isAddress(referrer)) return ZeroAddress;

  const normalized = getAddress(referrer);
  if (
    buyerAddress &&
    normalized.toLowerCase() === buyerAddress.toLowerCase()
  ) {
    return ZeroAddress;
  }

  return normalized;
};

export const getErrorData = (error) =>
  error?.data?.data ||
  error?.data ||
  error?.info?.error?.data ||
  error?.error?.data;

export const getContractErrorMessage = (error) => {
  console.error("Presale error:", error);

  let customErrorName =
    error?.revert?.name ||
    error?.errorName ||
    error?.data?.errorName;

  if (!customErrorName) {
    try {
      const data = getErrorData(error);
      if (typeof data === "string") {
        customErrorName = new Interface(PresaleContract?.abi)?.parseError(data)?.name;
      }
    } catch {
      // Continue with normal ethers error messages.
    }
  }

  const messages = {
    EnforcedPause: "Presale is currently paused.",
    ZeroPayment: "Payment amount must be greater than zero.",
    SaleAllocationExceeded: "The remaining presale allocation is insufficient.",
    InsufficientSaleInventory: "The presale contract does not have enough tokens.",
    SlippageExceeded: "The token price changed. Refresh the quote and try again.",
    InsufficientAllowance: "Stablecoin allowance is insufficient.",
    InsufficientPaymentBalance: "Your stablecoin balance is insufficient.",
    SelfReferralNotAllowed: "You cannot use your own wallet as a referrer.",
    InvalidReferrer: "The supplied referral address is not valid.",
    ReferrerAlreadyAssigned:
      "This wallet already has a different permanent referrer.",
  };

  if (customErrorName && messages[customErrorName]) {
    return messages[customErrorName];
  }

  if (error?.code === "ACTION_REJECTED" || error?.code === 4001) {
    return "Transaction was rejected in your wallet.";
  }

  const raw =
    error?.shortMessage ||
    error?.reason ||
    error?.info?.error?.message ||
    error?.message ||
    "Transaction failed. Please try again.";

  if (/insufficient funds/i.test(raw)) {
    return "You do not have enough BNB to pay the network gas fee.";
  }

  if (/wrong network|switch.*network|chain/i.test(raw)) {
    return raw;
  }

  return String(raw).replace(/^execution reverted:\s*/i, "");
};
